export const NEXT_MAINTAIN_KEY = 'nextMaintain';
export const CACHE_OBJECT_KEY = 'MachineTranslation_translationCacheObject';
export const DEFAULT_EXPIRATION_PERIOD = 7;
export const MAINTENANCE_PERIOD = 1;
